import { Address, ApplicationDto } from 'api/ApplicationApi';
import { HttpClient } from 'api/HttpClient';
import { BorrowerRole } from 'enums/BorrowerRole';

export interface UpdateContractorInformationDto {
  applicationId: string;
  fundedContractorName: string;
  fundedContractorSalespersonName: string;
  fundedContractorSalespersonPhone: string;
  fundedContractorSalespersonEmail: string;
}

export interface EmploymentInformationDto {
  name: string;
  position: string;
  phone: string;
  hireDate: Date;
  address: Address;
}

export interface EmploymentStatusInformationDto {
  governmentPaygrade: string;
  branchOfService: string;
  branchOfServiceRetired: string;
  militaryPaygrade: string;
  militaryPaygradeRetired: string;
  retirementDate: Date;
}

export interface UpdateEmploymentInformationDto {
  applicationId: string;
  borrowerType: BorrowerRole;
  employmentInformation?: EmploymentInformationDto[];
  previousEmploymentInformation?: EmploymentInformationDto;
  employmentStatusInformation?: EmploymentStatusInformationDto;
}

export default class EmploymentsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/employments' || '');
  }

  public async updateAdditionalContractorInformation(data: UpdateContractorInformationDto): Promise<ApplicationDto> {
    return this.instance.put('/contractor-information', data).then((response) => response.data);
  }

  public async updateAdditionalEmploymentInformation(data: UpdateEmploymentInformationDto): Promise<ApplicationDto> {
    return this.instance.put('/employment-information', data).then((response) => response.data);
  }
}

export const hilEmploymentsApi = new EmploymentsApi();
